interface CategoryCardProps {
    image: string;
    title: string;
    link: string;
}

function CategoryCard({ image, title, link }: CategoryCardProps) {
    return (
        <a
            href={link}
            className="relative block w-full h-60 rounded overflow-hidden group"
        >
            {/* Изображение категории */}
            <img
                src={image}
                alt={title}
                className="absolute inset-0 object-cover w-full h-full transition-transform duration-300 group-hover:scale-110"
            />
            {/* Оверлей с текстом */}
            <div className="absolute inset-0 bg-black/30 flex flex-col justify-end p-4 text-white">
                <h2 className="text-lg font-bold">{title}</h2>
                <button className="mt-2 px-4 py-2 bg-white text-black text-sm rounded hover:bg-gray-200"
                    style={{ width: "fit-content" }}>
                    Смотреть товары
                </button>
            </div>
        </a>
    );
}

export default CategoryCard;
